module.exports = __webpack_public_path__ + "img/header-lg.56c291a4.png";